import React, {useEffect, useState} from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next';


const InviteInput = ({ shop, settings, setParentCrewCartToken, userToken, setUserToken, rootUrl, crewcartMember, crewCart, setCrewcartMember, crewCartToken, setCrewCartToken }) => {

    const { t } = useTranslation();

    // State for name, email, and token
    const [user, setUser] = useState({ name: "", email: "", crewcart_name:"" });
    const [loading, setLoading] = useState(false);
    const [terms, setTerms] = useState(false);
    const [emailError, setEmailError] = useState("");

    useEffect(() => {

        console.log("INVITE INPUTTTTTT");
            console.log({crewcartMember});
            console.log({userToken});
            console.log({crewCartToken});
    }, [userToken, crewCartToken, crewcartMember]);


    useEffect(()=>{
        console.log("updated crewcart");
        console.log({crewCart});
    },[crewCart]);
    //once the user saves their data, we will request a crewcart token
    const getCrewcartToken = async (userToken) => {
        try {
            let res = await axios.post(`${rootUrl}/api/crewcart-token`, {
                user_token: userToken,
                shop: shop,
                name: user.name,
                email: user.email,
                crewcart_name: user.crewcart_name
            },{
                withCredentials: true // This is important for cookies to be set from cross-domain requests
            });

            setUserToken(res.data.crew_cart.cart_token);
            setCrewCartToken(res.data.crew_cart.crewcart.token);
            localStorage.setItem('crewCartUserId', res.data.crew_cart.cart_token);
            localStorage.setItem('crewCartToken', res.data.crew_cart.crewcart.token);
            setParentCrewCartToken(res.data.crew_cart.crewcart.token);
            return res?.data?.crew_cart?.crewcart?.token;
        } catch (err) {
            throw err;
        }
    };

    const handleCancel = () => {
        //remove the localStorage
        localStorage.removeItem("crewCartUserId");
        localStorage.removeItem("crewCartToken");
        localStorage.removeItem('hasSeenShare');

        window.parent.postMessage(
            {type: 'UNSUBSCRIBE_USER'},
            'https://' + shop
        );
        setUserToken(null);
        setCrewCartToken(null);
        //reload this whole frame

    }

    // Email validation function
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    // Handle input change with validation
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));

        // Clear email error when user starts typing
        if (name === 'email') {
            setEmailError("");
        }
    };


    const updateUser = async () => {
        setLoading(true);
        try {
            const res = await axios.put(`${rootUrl}/api/crewcart/member`, {
                crew_cart_token: crewCartToken,
                user_token: userToken,
                name: user.name,
                email: user.email
            });

            if(res.status === 200) {
                if(res.data.status === 'error' && res.data.message === 'crewcart_closed') {
                    alert(t('cartItems.crewcartClosed'));
                    // Clear any local storage and reload to reset the state
                    localStorage.removeItem("crewCartUserId");
                    localStorage.removeItem("crewCartToken");
                    window.location.reload();
                    return;
                }
                
                if(res.data.member) {
                    setLoading(false);
                    res.data.member.status = "SIGNING_UP";
                    setCrewcartMember(res.data.member);
                }
            }
        } catch (error) {
            console.error("Failed to update user:", error);
            setLoading(false);
            if (error.response?.data?.message === 'crewcart_closed') {
                alert(t('cartItems.crewcartClosed'));
                // Clear any local storage and reload to reset the state
                localStorage.removeItem("crewCartUserId");
                localStorage.removeItem("crewCartToken");
                window.location.reload();
            }
        }
    };

    useEffect(() => {

        console.log("DO WE HAVE A CREWCART TOKEN?");
        console.log({crewCartToken});
    },[crewCartToken]);
    // Handle "Shop Together" button click with validation
    const handleShopTogether = async () => {
        if (!terms) {
            alert("Please accept the Terms & Conditions");
            return false;
        }

        if (!validateEmail(user.email)) {
            setEmailError("Please enter a valid email address");
            return false;
        }

        if(!crewCartToken || crewCartToken == '') {
            console.log("no crewcart token yet");
            try {
                setLoading(true);
                const crewCartToken = await getCrewcartToken()

                if (crewCartToken) {
                    setCrewCartToken(crewCartToken);
                    setParentCrewCartToken(crewCartToken);

                    localStorage.setItem('crewCartToken', crewCartToken); // Save to localStorage
                    setLoading(false);




                } else {
                    console.error("API Error:", {crewCartToken});
                    setLoading(false);
                }
            } catch (error) {
                console.error("Request Failed:", error);
                setLoading(false);
            }
        }else{
            //we need to just update the member data, we already have a crewcart token
            if(!crewcartMember.name) {
                updateUser();
            }
        }


        console.log("request check cart items");


        //if shop does not have myshopify.com we will append it

        window.parent.postMessage(
            { type: 'CHECK_CART_ITEMS'},
            'https://' + shop
        );



    };

    return (
        <div className="input-group flex-column invite-form">
            <style>
                {`
          .invite-form .input-group {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
          }
          .create-form .heading{
          font-size:1.1em;
          }

          .invite-form .input-group .form-control {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          .invite-form .input-group .btn-primary {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background-color:#000;
            margin-left: -1px; /* Prevent overlapping borders */
            height: 38px;
            padding: 10px;
            font-size: 13px;
          }

          .invite-form .btn-shop {
            background-color:#000;
            color: white;
            border: none;
            padding: 10px 20px;
            cursor: pointer;
            text-align:center;
          }
          .btn-shop.loading{
          display:inline;
          }
          .crewCartTerms{
          color:#000;
          }



          .is-invalid {
            border-color: #dc3545;
            padding-right: calc(1.5em + 0.75rem);
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right calc(0.375em + 0.1875rem) center;
            background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
          }

          .invalid-feedback {
            display: block;
            width: 100%;
            margin-top: 0.25rem;
            font-size: 0.875em;
            color: #dc3545;
          }
        `}
            </style>

            {!crewcartMember.name &&

                <div className={"create-form"}>
                    <strong className={"heading"}>{userToken && !crewcartMember.name ? t('createCrewcart.join') : t('createCrewcart.create')}</strong><br /><br />
                    {userToken && !crewcartMember.name && <div className={"col-12 mb-4"}> {t('createCrewcart.welcome')} <strong>{ crewCart.name }</strong> crewcart!<br /> {t('createCrewcart.enterName')}</div>}
                        <input
                            required
                            autoComplete="off"
                            type="text"
                            className="form-control p-2"
                            placeholder={t('createCrewcart.name')}
                            name="name"
                            value={user.name}
                            onChange={handleInputChange}
                        />

                        <input
                            required
                            autoComplete="off"
                            type="email"
                            className={`form-control p-2 ${emailError ? 'is-invalid' : ''}`}
                            placeholder={t('createCrewcart.email')}
                            name="email"
                            value={user.email}
                            onChange={handleInputChange}
                        />
                        {emailError && (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                {emailError}
                            </div>
                        )}
                        {!userToken &&
                    <input
                        required
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder={`${t('createCrewcart.crewcartName')} (max 19 chars)`}
                        name="crewcart_name"
                        value={user.crewcart_name}
                        onChange={handleInputChange}
                        maxLength={19}
                    />
                }

                    {!crewcartMember.name &&
                        <div><br/>
                            <label><input type={"checkbox"} name={"terms"}
                                          onChange={(e) => setTerms(e.target.checked)}/> {t('createCrewcart.terms')} <a
                                href="https://www.crewcart.com/terms" target="_blank" rel="noopener noreferrer"
                                className={"crewCartTerms"}>{t('createCrewcart.termsText')}</a> {t('createCrewcart.ofCrewcart')}
                            </label>
                            <br/><br/>

                            <div className="button-container" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column-reverse',
                                    gap: '10px',
                                    width: '100%',
                                    '@media (min-width: 768px)': {
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                    }
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                        '@media (min-width: 768px)': {
                                            flex: 1,
                                            maxWidth: '200px'
                                        }
                                    }}>
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={handleCancel}
                                            style={{
                                                backgroundColor: 'white',
                                                border: '1px solid black',
                                                color: 'black',
                                                padding: '10px 20px',
                                                borderRadius: '0',
                                                width: '100%',
                                                height: '42px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {t('signup.cancel')}
                                        </button>
                                        <span className={"subtext"} style={{ marginTop: '5px' }}>{t('signup.subText')}</span>
                                    </div>
                                    <div style={{
                                        width: '100%',
                                        '@media (min-width: 768px)': {
                                            flex: 1,
                                            maxWidth: '250px'
                                        }
                                    }}>
                                        <button
                                            className={loading ? `btn btn-primary-crewcart rounded-0 loading` : `btn btn-primary-crewcart rounded-0 done-shopping`}
                                            type="button"
                                            onClick={handleShopTogether}
                                            style={{
                                                width: '100%',
                                                padding: '10px 10px',
                                                height: '42px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            disabled={loading}
                                        >
                                            {loading ? <img src="/images/loading_white_transparent.gif" width={16}
                                                style={{marginTop: "-5px"}}/> : <>
                                                <span>{t('createCrewcart.startShopping')}</span> <span
                                                className="text-xl ml-2">→</span></>}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                </div>}
        </div>
    );
};

export default InviteInput;
